module.exports = __webpack_public_path__ + "img/216.6035cc95.jpg";